// This file manages exports from the base atom, molecule, or organism.

// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import { AccordionCardWrapperProps } from './AccordionCardWrapper.types';

const AccordionCardWrapper = dynamic(() => import('./AccordionCardWrapper').then(mod => mod.AccordionCardWrapper));

export const AccordionCardWrapperConfig = {
  emptyLabel: 'AccordionCardWrapper',
  isEmpty: () => true,
  resourceType: `mi-aem-account/components/content/accordion`,
};

type editableCompAccountPartnerCardWrapperProps = EditableComponentProps & AccordionCardWrapperProps;

export const AccordionCardWrapperEditable = (props: editableCompAccountPartnerCardWrapperProps) => (
  // editable component export
  <EditableComponent config={AccordionCardWrapperConfig} {...props}>
    <AccordionCardWrapper {...props} />
  </EditableComponent>
);
